import { render, staticRenderFns } from "./ParcelamentoForm.vue?vue&type=template&id=1ca70605&scoped=true&"
import script from "./ParcelamentoForm.vue?vue&type=script&lang=js&"
export * from "./ParcelamentoForm.vue?vue&type=script&lang=js&"
import style0 from "./ParcelamentoForm.vue?vue&type=style&index=0&id=1ca70605&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca70605",
  null
  
)

export default component.exports